import * as types from './actionTypes';

export function initializeSearch() {
	return {
		type: types.INITIALIZE_SEARCH
	};
}

export function toggleFilterDisplay() {
	return {
		type: types.TOGGLE_FILTER_DISPLAY
	};
}

export function searchInputBlur() {
	return {
		type: types.SEARCH_INPUT_BLUR
	};
}

export function searchInputFocus() {
	return {
		type: types.SEARCH_INPUT_FOCUS
	};
}

export function searchInputDirty() {
	return {
		type: types.SEARCH_INPUT_DIRTY
	};
}


/** WEBPACK FOOTER **
 ** ./src/modules/search/actions.js
 **/